// extracted by mini-css-extract-plugin
module.exports = {"modalWindow":"Popup_modalWindow__2Ljee","modalBg":"Popup_modalBg__2n1c_","modalContent":"Popup_modalContent__13PN7"};